import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';

import FooterLinks from 'PointOfSale/modules/common/component/FooterLinks';
import { checkout } from 'PointOfSale/modules/teacher/state/actions';
import * as POSSelectors from 'PointOfSale/selectors';
import { createToast, toastType } from 'Common/ToastHelper';

class TeacherFooterContainer extends Component {
  onCheckoutClicked = async () => {
    const { hasQSI, checkout } = this.props;

    if (!hasQSI) {
      createToast(
        toastType.error,
        'Error',
        'Nothing selected to serve. Transactions not processed.'
      );
      return;
    }

    const numSuccessful = await checkout();
    if (numSuccessful > 0) {
      createToast(
        toastType.success,
        'Success',
        numSuccessful === 1
          ? `${numSuccessful} student was served`
          : `${numSuccessful} students were served`
      );
    }
  };

  render() {
    const { students, teacher, writing } = this.props;
    if (_.isEmpty(teacher)) {
      return null;
    }

    const hasStudentsSelected = students.filter(s => s.selected).length > 0;

    const isDisabled = writing || !hasStudentsSelected;

    return (
      <FooterLinks
        options={[
          {
            type: 'Checkout',
            isDisabled,
          },
        ]}
        onClickHandler={this.onCheckoutClicked}
      />
    );
  }
}

TeacherFooterContainer.propTypes = {
  teacherActions: PropTypes.object,
  teacher: PropTypes.string,
  selected: PropTypes.object,
};

const mapStateToProps = state => ({
  students: POSSelectors.getStudentsForTeacher(state),
  teacher: POSSelectors.getTeacher(state),
  writing: POSSelectors.getTeacherWriting(state),
  hasQSI: POSSelectors.getHasQuickServeItem(state),
});

const mapDispatchToProps = {
  checkout,
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(TeacherFooterContainer)
);



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/layouts/container/TeacherFooterContainer.js